module.exports = __webpack_public_path__ + "static/media/Screenshot 2024-08-18 at 11.54.24.8c2f9c65.png";